export const validateEmail = (email: string) => {
  if (email === '') return true;
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const formatToTwoDecimals = (num: number) => {
  return Math.round(num * 100) / 100;
};

export const cropImage = async (
  imgUri: string,
  xstart = 0,
  ystart = 0,
  width = 400,
  height = 300,
  callback: (newimgUri: string) => void
): Promise<any> => {
  try {
    let resize_canvas = document.createElement('canvas');
    let orig_src = new Image();
    orig_src.src = imgUri;
    orig_src.onload = function () {
      resize_canvas.width = width;
      resize_canvas.height = height;
      let cnv = resize_canvas.getContext('2d');
      cnv?.drawImage(orig_src, xstart, ystart, width, height, 0, 0, width, height);
      let newimgUri = resize_canvas.toDataURL('image/jpeg').toString();
      callback(newimgUri);
    };
  } catch (err) {
    return err;
  }
};
